import React, { useState, useEffect, Fragment } from 'react';

import { Card, CardBody, CardTitle, Button, Spinner } from 'reactstrap';
import moment from 'moment';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

const OrderList = ({
  data,
  orderId,
  currency,
  hanldeOrderId,

}) => {  
  const [items, setItems] = useState(data);  
  const [itemsNum, setItemsNum] = useState(items || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setItems(data);
    setTimeout(()=>{
       setLoading(false);
    },2000);
  }, [data]);
 


  const [showButton, setShowButton] = useState(false);
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 10 <= e.target.clientHeight;
    if (bottom && items.length > 0) {
      setShowButton(true);
    }
  };  
  return (
    <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4">
      <Card
        className="cardHeight"
        style={{ overflow: 'scroll' }}
        onScroll={handleScroll}
      >
        <CardBody>
          <div className="scroll">
            {items.length > 0 && (
              <div>
                <div>
                  {items.map((m, index) => {
                    return (
                      <div
                        key={`m${index}`}
                        onClick={() => hanldeOrderId(m.voucherNumber)}
                        className={
                           m.voucherNumber ===orderId
                            ? 'd-flex flex-row  border-bottom  selected-div'
                            : 'd-flex flex-row  border-bottom '
                        }
                        style={{ cursor: 'pointer',paddingTop:'0.75rem',paddingLeft:'-0.5rem' }}                 
                      >
                        <div className="d-block pl-2">
                          <div className='orderList-discount'>
                            {m.isCard === true ? parseFloat(m.balance,2): parseFloat(m.discountedPrice,2)}
                          </div>
                        </div>
                        <div className='order-status' style={{color:`${m.redeem === 'NotRedeemed' ? '#2F9A63' : 'rgb(221, 24, 24)' }`}}>
                          <span className=''>{m.redeem === 'NotRedeemed' && 'Available'} {m.redeem === 'Void' && 'Void'} {m.redeem === 'Redeem' && 'Redeemed'} {m.redeem === 'Refund' && 'Refunded'}</span>
                        </div>
                        <div className="pl-3 pt-2 pr-2 pb-2 ">
                          <div className="pr-4">
                            <div className=" text-small font-weight-medium d-none d-sm-block mb-1">
                              {moment(m.createdDate).format(
                                'DD/MM/YYYY h:mm a'
                              )}
                              &nbsp;
                            </div>

                            <p className="mb-1 text-small orderList-title" style={{paddingTop:'0.4rem'}}>{m.name}</p>

                            <p className="text-muted mb-1 text-small">
                              {m.email}
                              {m.email !== "" && m.email !== null &&
                                <span className='ml-1' style={{ cursor: "pointer" }}>
                                  {/* <FontAwesomeIcon icon={isMasked === "true" ? faLock : faLockOpen} className="fa" /> */}
                                </span>
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
              {loading ===true && (
                <div className="mx-auto my-auto text-center">
                  <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                </div>
              )}
          </div>        
          {/* {showButton && (
            <Button
              style={{ margin: '8px 0', float: 'right' }}
              color="primary"
              size="sm"
            // onClick={loadMore}
            >
              More
            </Button>
          )} */}
        </CardBody>
      </Card>
    </Colxx>
  );
};

export default OrderList;
